import api from 'Plugins/api'

class NoticeInteractor {
  /**
   * 获取最新的公告通知 用于首页和我的展示
   */
  static async getLoginNotice(flag) {
    try {
      const { data = {} } = await api['common/getLoginTz']({ flag })
      
      if (data.list) {
        data.list.forEach(notice => {
          notice.id = notice.tzId
        })
      } else {
        data.list = []
      }
      
      return {
        data: data,
      }
    } catch (error) {
      throw error
    }
  }
  
  /**
   * 消息中心列表
   */
  static async getNoticeList(status, pageNum, count) {
    try {
      const { data = {} } = await api['common/recipientGgtz']({
        status,
        pageNum,
        count
      })
      
      return {
        data: data || []
      } 
    } catch (error) {
      throw error
    }
  }

  /**
   * 根据通知Id获取通知的详情信息
   */
  static async getNoticeById(id) {
    try {
      const { data = {} } = await api['common/getTzContent']({ id })

      data.status = data.status || 0

      return {
        data
      }
    } catch (error) {
      throw error
    }
  }
  
  /**
   * 标记已读
   */
  static async readNotice(id) {
    try {
      await api['common/readGgtz']({ id })

      return true
    } catch (error) {
      throw error
    }
  }

}

export default NoticeInteractor